/* eslint-disable */
const routeNotice = [
    {
        path: '/notices',
        name: 'NoticeList',
        component: () => import('../pages/notice/NoticeList.vue'),
        meta: {
            layout: 'HomeLayout',
        },
    },
    {
        path: '/notices/add',
        name: 'AddNotice',
        component: () => import('../pages/notice/AddNotice.vue'),
        meta: {
            layout: 'HomeLayout',
        },
    },
    {
        path: '/notices/edit/:id',
        name: 'EditNotice',
        component: () => import('../pages/notice/AddNotice.vue'),
        meta: {
            layout: 'HomeLayout',
        },
    },
    {
        path: '/notices/notice/:id',
        name: 'NoticeDetail',
        component: () => import('../pages/notice/NoticeDetail.vue'),
        meta: {
            layout: 'HomeLayout',
        },
    },
]
  
export default routeNotice;